import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localizedNumber',
  pure: false
})
export class LocalizedNumberPipe implements PipeTransform {
  constructor(
  ) {}

  transform(value: any, pattern: string = '1.0'): any {
    // const numberPipe: DecimalPipe = new DecimalPipe(this.translateService.currentLang + '-CA');
    const numberPipe: DecimalPipe = new DecimalPipe(this.getLanguageAndCulture());

    return numberPipe.transform(value, pattern);
  }

  getLanguageAndCulture() {
    const lang = localStorage.getItem('lang') || 'en';
    const culture = localStorage.getItem('culture') || 'GB';
    return lang + '-' + culture;
  }
}
